import {  updateHeader ,getHeader} from "../../../contextapi/Endpoints/Endpoints";
import { apiSlice } from "../../app/api/apiSlice";

export const headerApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getHeaderHindi: builder.query({
            query: () => ({
                url: `${getHeader}/hindi`,
                method: 'GET'
            })
        }),
        getHeaderEnglish: builder.query({
            query: () => ({
                url: `${getHeader}/english`,
                method: 'GET'
            })
        }),
        updateHeader: builder.mutation({
            query: (newHeader) => {
                return {
                    url: updateHeader,
                    method: 'POST',
                    body: newHeader,
                }
            }
        })
    })
})
export const {useGetHeaderHindiQuery,useUpdateHeaderMutation,useGetHeaderEnglishQuery} =headerApiSlice